import { KeyAmount } from 'src/app/shared/models/interface/concretes/key-amount.interface';
import { PackageVM } from 'src/app/shared/models/interface/concretes/offer-customize-custom.interface';

export type SummaryOfferState = {
  package: PackageVM | null;
  options: KeyAmount[];
};

export const initialSummaryOfferState: SummaryOfferState = {
  package: null,
  options: [],
};
